import { useClassNames } from "../../../structure";
import { H2Props } from "./H2.types";

export default function H2({ children, classNames }: H2Props) {
  const style = useClassNames(classNames || ["h2"]);
  return <h2 style={style}>{children}</h2>;
}
